// @flow
import styled from "styled-components";
import { Link } from "react-router-dom";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontCondensed } from "@fdr/static-ui/Typography";

export const RaceSelectorListItem = styled.li`
  list-style: none;
  border-bottom: 1px solid ${buildColor("grey", "300")};

  &:last-child {
    border-bottom: none;
  }
`;

export const RaceSelectorLink = styled(Link)`
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-decoration: none;
  color: ${buildColor("grey", "D3")};
`;

export const RaceSelectorInfo = styled.div`
  width: calc(100% - 24px);
`;

export const RaceNumberPromo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 8px 0 8px;
`;

export const RaceNumber = styled.div`
  font-size: 18px;
  line-height: 125%;
  color: ${buildColor("grey", "D4")};
  display: flex;
  align-items: center;
`;

export const Highlighted = styled.div`
  font-weight: bold;

  &::after {
    content: "·";
    margin: 0 4px;
  }
`;

export const Promo = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  font-family: ${fontCondensed};
  font-size: 14px;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: ${buildColor("navy", "900")};
  padding-right: 12px;

  & > svg {
    margin-right: 8px;
  }

  &::after {
    content: "";
    position: absolute;
    top: -1px;
    left: 3px;
    background-color: ${buildColor("yellow", "600")};
    border-radius: 50%;
    width: 6px;
    height: 6px;
    border: 1px solid white;
  }

  &.optin {
    & > svg {
      transform: scaleX(-1);
    }

    &::after {
      background-color: ${buildColor("green", "500")};
      left: 6px;
    }
  }
`;
